<template>
    <Badge
        class="inline-flex"
        color="secondary"
    >
        <div class="flex items-center gap-1">
            <Icon
                name="arrow-rotate"
                class="w-2.5 h-2.5"
            />
            <span> Recurring </span>
        </div>
    </Badge>
</template>

<script setup lang="ts">
    import Badge from '@/Shared/Component/Badge.vue'
    import Icon from '@/Shared/Component/Icon.vue'
</script>
